"use client"

import { useState } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { 
  X, 
  MapPin, 
  Clock, 
  Calendar,
} from "lucide-react"
import { Event as ScenarioEvent } from "@/lib/test-scenarios"

interface EventSummaryProps {
  event: ScenarioEvent
  onClose: () => void
  onThankYou?: () => void
  gratitudeSent?: boolean
}

export function EventSummary({ event, onClose, onThankYou, gratitudeSent }: EventSummaryProps) {
  const formatDateTime = (date: Date) => {
    return new Intl.DateTimeFormat('he-IL', {
      dateStyle: 'short',
      timeStyle: 'short'
    }).format(date)
  }

  const formatDuration = (start: Date, end: Date) => {
    const diff = end.getTime() - start.getTime()
    const minutes = Math.floor(diff / (1000 * 60))
    if (minutes < 60) return `${minutes} דקות`
    const hours = Math.floor(minutes / 60)
    const remainingMinutes = minutes % 60
    return `${hours} שעות ו-${remainingMinutes} דקות`
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <Card className="w-full max-w-lg max-h-[90vh] overflow-hidden">
        <CardHeader className="relative pb-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="absolute left-2 top-2 h-8 w-8 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
          <CardTitle className="text-center text-xl">סיכום אירוע</CardTitle>
        </CardHeader>
        
        <CardContent className="overflow-y-auto space-y-6 pb-6">
          {/* Event Photos */}
          {/* {photos.length > 0 && (
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm font-semibold">
                <Camera className="h-4 w-4" />
                <span>תמונות מהאירוע</span>
              </div>
              <div className="grid grid-cols-2 gap-2">
                {photos.map((photo, index) => (
                  <img
                    key={index}
                    src={photo}
                    alt={`תמונה ${index + 1} מהאירוע`}
                    className="w-full h-32 object-cover rounded-lg border"
                  />
                ))}
              </div>
            </div>
          )} */}

          {/* Event Details */}
          <div className="space-y-4">
            <div className="bg-muted/50 p-4 rounded-lg space-y-3">
              <h3 className="font-semibold text-lg">{event.type}</h3>
              <p className="text-sm text-muted-foreground">{event.description}</p>
              
              <div className="space-y-2 pt-2">
                <div className="flex items-center gap-2 text-sm">
                  <MapPin className="h-4 w-4 text-muted-foreground" />
                  <span>{event.location}</span>
                </div>
                
                <div className="flex items-center gap-2 text-sm">
                  <Calendar className="h-4 w-4 text-muted-foreground" />
                  <span>{formatDateTime(event.createdAt)}</span>
                </div>
                
                <div className="flex items-center gap-2 text-sm">
                  <Clock className="h-4 w-4 text-muted-foreground" />
                  <span>משך טיפול: {formatDuration(event.createdAt, event.updatedAt)}</span>
                </div>
              </div>
            </div>
            {/* Status Timeline Summary */}
            {/* {statusHistory.length > 0 && (
              <div className="space-y-2">
                <h4 className="font-semibold text-sm">ציר זמן מלא</h4>
                <div className="bg-muted/30 p-3 rounded-lg">
                  <div className="space-y-1 text-xs">
                    {statusHistory.map((item, index) => (
                      <div key={index} className="flex justify-between">
                        <span className="text-muted-foreground">{getStatusLabel(item.status)}</span>
                        <span>{formatDateTime(item.timestamp)}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )} */}
          </div>

          {/* Thank You Button */}
          {!gratitudeSent && onThankYou && (
            <div className="pt-4">
              <Button
                onClick={onThankYou}
                className="w-full bg-green-600 hover:bg-green-700"
                size="lg"
              >
                שלח הודעת תודה למתנדב
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
